import React from "react";
import styles from "./Menu.module.css";
import { useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import Auth from "../../utils/api/Auth";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { userDataActions } from "../../store/redux-store/Index";

function Menu() {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const token = useSelector((state) => state.userData.loginData.token);

  const userDetails = useSelector((state) => state.userData.personalInfo);

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type,
  );

  const handleLogout = async (e) => {
    e.stopPropagation();
    try {
      const logoutRes = await Auth.logoutHandler({
        token,
      });
      dispatch(userDataActions.logout());
      navigate("/login");
      return logoutRes.data;
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className={styles.menu__modal}>
        <div className={styles.menu__modal__inner}>
          <div className={styles.modal__header}>
            {/* <div className={styles.wrapper}>
              <img src={image} alt="profile" />
            </div> */}
            <div>
              <h4>{userDetails?.fullname}</h4>
              <p>{userDetails?.wallet?.business_name}</p>
            </div>
          </div>
          <div className={styles.menu__modal__list}>
            {accountType === "DISTRIBUTOR" && (
              <div className={`${styles.nav_container}`}>
                <NavLink to="/insurance-sync">
                  <div className={styles.title}>
                    <p>Insurance Sync</p>
                  </div>
                </NavLink>
              </div>
            )}

            <div className={`${styles.nav_container}`}>
              <NavLink
                to={
                  accountType !== "DISTRIBUTOR"
                    ? `/pin-history/exported-pins`
                    : `/pin-history/sold-pins`
                }
              >
                <div className={styles.title}>
                  <p>Orders History</p>
                </div>
              </NavLink>
            </div>

            <div className={`${styles.nav_container}`}>
              <NavLink to={`/terms`}>
                <div className={styles.title}>
                  <p>Terms and Conditions</p>
                </div>
              </NavLink>
            </div>

            <div className={`${styles.nav_container}`}>
              <NavLink to={`/privacy`}>
                <div className={styles.title}>
                  <p>Privacy Policy</p>
                </div>
              </NavLink>
            </div>
            <div
              className={`${styles.nav_container} ${styles.logout}`}
              onClick={(e) => {
                handleLogout(e);
              }}
            >
              <NavLink>
                <div className={styles.svg}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.5 22.5H13.5C13.8977 22.4996 14.279 22.3414 14.5602 22.0602C14.8414 21.779 14.9996 21.3977 15 21V18.75H13.5V21H4.5V3H13.5V5.25H15V3C14.9996 2.6023 14.8414 2.221 14.5602 1.93978C14.279 1.65856 13.8977 1.5004 13.5 1.5H4.5C4.1023 1.5004 3.721 1.65856 3.43978 1.93978C3.15856 2.221 3.0004 2.6023 3 3V21C3.0004 21.3977 3.15856 21.779 3.43978 22.0602C3.721 22.3414 4.1023 22.4996 4.5 22.5Z"
                      fill="#FD4D1E"
                    />
                    <path
                      d="M15.4395 15.4395L18.129 12.75H7.5V11.25H18.129L15.4395 8.5605L16.5 7.5L21 12L16.5 16.5L15.4395 15.4395Z"
                      fill="#FD4D1E"
                    />
                  </svg>
                </div>
                <div className={styles.title}>
                  <p>Logout</p>
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
